import { render, staticRenderFns } from "./OrderId.vue?vue&type=template&id=7b219b02"
import script from "./OrderId.vue?vue&type=script&lang=js"
export * from "./OrderId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports